<template>
  <div>
    <BlockTopContent />

    <v-container fluid class="dashboard-container">
      <router-view></router-view>
    </v-container>

    <!-- Сообщение выведено из потока намеренно. В потоке оно стояло над
         рабочей областью, а выставляется по ответу сервера — и появление
         «смена ещё не начата» на старте сдвигало вниз всю страницу.
         Плавающей плашке место резервировать не нужно, поэтому её приход
         ничего не двигает. Закрывается вручную: состояния вроде незакрытой
         смены сами не проходят, а перечитывать их каждый раз незачем. -->
    <div v-if="alert.active" class="sts-alert-dock">
      <v-alert
        :type="alert.type"
        dense
        dismissible
        class="sts-alert-dock__body"
        @input="closeAlert"
      >
        {{ alert.message }}
      </v-alert>
    </div>
  </div>
</template>

<script>
// Полоса пути есть на каждой странице и стоит над рабочей областью. Отдельным
// чанком она домонтировалась после первого кадра и толкала вниз весь контент —
// отсюда брался самый крупный сдвиг вёрстки. Импорт обычный.
import BlockTopContent from "./BlockTopContent.vue";
export default {
  name: 'BlockContent',
  components: {
    BlockTopContent
  },
  computed: {
    alert () {
      return this.$store.state.alert
    }
  },
  methods: {
    closeAlert () {
      this.$store.commit('closeAlert')
    }
  }
}
</script>

<style scoped>
/* Плашка висит в правом нижнем углу. Что-то она перекрывает неизбежно, и угол
   выбран как наименее ценный: по центру она ложилась на строку итогов, сверху
   легла бы на заголовок страницы и выбор периода. */
.sts-alert-dock {
  position: fixed;
  right: 16px;
  bottom: 16px;
  z-index: 6;
  width: max-content;
  max-width: min(420px, calc(100vw - 32px));
  /* Док растянут шире плашки, и без этого он ловил бы клики по таблице. */
  pointer-events: none;
}

.sts-alert-dock__body {
  margin: 0;
  pointer-events: auto;
  box-shadow: var(--sts-shadow);
}
</style>
